const s = require("./select.module.scss");

import { default as React, useState } from "react";
import classnames from "classnames";

export interface SelectItem {
    id: string;
    text: string;
}
interface Props {
    data: SelectItem[];
    enabled: boolean;
    selectedItem: SelectItem;
}

interface DispatchProps {
    onChange: (item: SelectItem) => void;
}
interface State {
    open: boolean;
}

const Select = ({ data, enabled, selectedItem, onChange }: Props & DispatchProps) => {
    const initialState: State = { open: false };
    const [state, setState] = useState(initialState);
    const [search, setSearch] = useState("");

    const interceptEvent = (event: any) => {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
    };
    const renderListItem = (item: SelectItem) => {
        const className = classnames(s.dropdownitem, item.id === selectedItem.id ? s.selected : s.notselected);
        return (<a key={item.id} className={className} onClick={(e) => { handleChange(e, item); }} onMouseDown={handleMouseDown} onBlur={handleBlur} href="#">{item.text}</a>);
    };

    const handleChange = (event: any, item: SelectItem) => {
        clickedOnOption = false;
        interceptEvent(event);
        onChange(item);
        handleClose(event);
    };
    const handleClose = (event: any) => {
        interceptEvent(event);
        if (!clickedOnOption) {
            setState({ open: false });
        }
        clickedOnOption = false;
    };
    let clickedOnOption: Boolean = false;
    let blurTimeout: any = undefined;
    const handleBlur = () => {
        clearTimeout(blurTimeout);
        blurTimeout = setTimeout(handleClose, 0);
    };
    const toggleOpenClose = (event: any) => {
        interceptEvent(event);
        setState({ open: !state.open });
        if (state.open) {
            return setState({ open: false });
        }
        setSearch("");
    };
    const handleMouseDown = () => {
        clickedOnOption = true;
    };

    const classNameInput = classnames(s.textField, "inputBorder", enabled ? s.enabled : s.disabled, state.open ? s.xxx : "");
    const classNameDropDown = classnames(s.dropdownmenu, state.open ? "" : s.hidden);
    const classNameSearch = classnames("inputBorder", s.search, state.open ? "" : s.hidden);

    const selectedItems = data.filter((f) => { return f.id === selectedItem.id; });

    return (<div>
        <button className={classNameInput} onClick={toggleOpenClose} onBlur={handleBlur}>
            {data === undefined ? "None available"
                : data.length === 0 ? "None available"
                    : selectedItems.length === 0 ? ""
                        : selectedItems[0].text}
        </button>
        <input type="text"
            onFocus={handleMouseDown}
            onBlur={handleBlur}
            className={classNameSearch}
            placeholder="search..."
            value={search}
            onChange={(e) => setSearch(e.currentTarget.value)} />
        <div className={classNameDropDown}>
            {
                data && data.filter((d) => d.text.toLowerCase().includes(search.toLowerCase())).map(renderListItem)
            }
        </div>
    </div>);
};

export default Select;